import { render, staticRenderFns } from "./NotificationsManager.vue?vue&type=template&id=4ee700fb&scoped=true"
import script from "./NotificationsManager.vue?vue&type=script&lang=js"
export * from "./NotificationsManager.vue?vue&type=script&lang=js"
import style0 from "./NotificationsManager.vue?vue&type=style&index=0&id=4ee700fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee700fb",
  null
  
)

export default component.exports